



















import Vue from 'vue';
import _, { debounce } from 'underscore';
import { Project, Pagination, MechanicInstallation } from '@/types';

import Installations from '@/components/Installations';

export default Vue.extend({
  components: {
    Installations,
  },

  data() {
    return {
      query: '',
    };
  },

  computed: {
    isPending(): boolean {
      return this.$store.getters['installations/isPending'];
    },

    page(): Pagination<MechanicInstallation> {
      return this.$store.getters['installations/page']();
    },

    installations(): MechanicInstallation[] {
      return _.sortBy(this.page?.data, 'pchn');
    },
  },

  methods: {
    search: debounce(function(this: any) {
      this.$store.dispatch('installations/fetch:all:page', {
        params: { searchTerm: this.query },
        perPage: 50,
      });
    }, 500),
  },

  watch: {
    query: {
      handler(query: string) {
        if (query.length > 2) {
          this.search();
        }
      },
      immediate: true,
    },
  },
});
